import { API } from './resources'

export default {
  getConversations: (username, query, limit, offset) => {
    return API.get(`/users/${username}/conversations`, { params: { query, limit, offset } })
  },
  getPublicConversations: (query, limit, offset) => {
    return API.get('/conversations/public', { params: { query, limit, offset } })
  },
  getConversation: (id) => {
    return API.get(`/conversations/${id}`)
  },
  getConversationToMessage: (conversationID, messageID) => {
    return API.get(`/conversations/${conversationID}/message/${messageID}`)
  },
  getUsersInConversation: (id, limit, offset) => {
    return API.get(`/conversations/${id}/users`, { params: { limit, offset } })
  },
  getMessagesInConversation: (id, limit, before, since) => {
    return API.get(`/conversations/${id}/messages`, { params: { limit, before, since } })
  },
  getMessagesInPublicConversation: (id, limit, before, since) => {
    return API.get(`/conversations/${id}/publicmessages`, { params: { limit, before, since } })
  },
  getPinnedMessagesInConversation: (id, limit, offset) => {
    return API.get(`/conversations/${id}/messages`, { params: { limit, offset, query: 'pinned' } })
  },
  updateConversationNotificationSettings: (id, notification) => {
    return API.put(`/conversations/${id}/users`, { notification })
  },
  createConversation: (users) => {
    return API.post('/conversations', { users })
  },
  addUserToConversation: (id, { userName, isSupervisor }) => {
    return API.post(`/conversations/${id}/users`, { userName, isSupervisor })
  },
  sendMessage: (id, message, chatType) => {
    return API.post(`/conversations/${id}/messages`, { message, chatType })
  },
  pinMessage: (id, pinned) => {
    return API.put(`/messages/${id}/pinned`, { pinned })
  },
  pinConversation: (id, pinned) => {
    return API.put(`/conversations/${id}/pinned`, { pinned })
  },
  getUnreadCount: (username) => {
    return API.get(`/users/${username}/conversations/unread`)
  },
  markConversationRead: (id) => {
    return API.put(`/conversations/${id}/read`)
  },
  getProjectConversation: (id) => {
    return API.get(`/projects/${id}/conversation`)
  },
  createProjectConversation: (id) => {
    return API.post(`/projects/${id}/conversation`)
  },
  createChatConversation: (id, chatType) => {
    return API.post(`/projects/${id}/chat/${chatType}`)
  },
  getChatConversation: (id, chatType) => {
    return API.get(`/projects/${id}/chat/${chatType}`)
  },
  getPublicConversationByTopic: (topic) => {
    return API.get(`/conversations/public/${topic}`)
  },
  getGroupConversationByTopic: (topic) => {
    return API.get(`/conversations/group/${topic}`)
  },
  hasLiked: (id, username) => {
    return API.get(`/messages/${id}/like/${username}`)
  },
  getLikes: (id, limit, offset) => {
    return API.get(`/messages/${id}/likes`, { params: { limit, offset } })
  },
  like: (id) => {
    return API.post(`/messages/${id}/like`)
  },
  unlike: (id) => {
    return API.delete(`/messages/${id}/like`)
  },
  updateMessage: (id, message) => {
    return API.put(`/messages/${id}`, { message })
  },
  deleteMessage: (id, showPermission) => {
    return API.delete(`/messages/${id}/${showPermission}`)
  },
  removeUserFromConversation: (id, user) => {
    return API.post(`/conversations/${id}/user`, { user })
  },
  updateUserConversationRole: (conversationid, userID, isSupervisor) => {
    return API.put(`/conversations/${conversationid}/user`, { userID, isSupervisor })
  },
  createGroupConversation: (data) => {
    return API.post('/conversations/group', data)
  },
  updateGroupConversation: (id, data) => {
    return API.put(`/conversations/${id}`, data)
  },
  getUserConversationRole: (id) => {
    return API.get(`/conversation/${id}/user/role`)
  }
}
